const styles = () => {
  return {
    root: { backgroundColor: '#FFFFFF', maxWidth: '720px' },
    datalimitsList: {
      display: 'flex',
      width: '100%',
      margin: '5px 0 10px 25px',
      alignItems: 'center'
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontSize: '16px',
      overflow: 'visible'
    },
    tooltip: { cursor: 'default' },
    infoIcon: {
      marginLeft: '10px'
    }
  };
};

export default styles;
